import { render } from "./PermissionsField.vue?vue&type=template&id=5b3f3a81"
import script from "./PermissionsField.vue?vue&type=script&lang=js"
export * from "./PermissionsField.vue?vue&type=script&lang=js"

import "./PermissionsField.vue?vue&type=style&index=0&id=5b3f3a81&lang=css"

import exportComponent from "/Users/hamid/Nova/onsho24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"PermissionsField.vue"]])

export default __exports__